import { CandidateService } from './../../service/candidate.service';
import { Component, OnInit, AfterContentInit, Input } from '@angular/core';
import { Constants } from '../../constant';
import { ActivatedRoute, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { Location } from '@angular/common';
import { SessionService } from '../../service/session.service';
import { AuthService } from '../../service/auth.service';
import { CandidateModel } from '../../model/candidate';

@Component({
  selector: 'app-candidate-statement',
  templateUrl: './candidate-statement.component.html',
  styleUrls: ['./candidate-statement.component.scss']
})
export class CandidateStatementComponent implements OnInit, AfterContentInit {
  readonly CONSTANTS = Constants;
  candidateDetail: any;
  error: string;
  mobile: boolean;
  position: number;
  totalCompleted: number = 0;
  candidates: CandidateModel[];

  @Input() candidateStatement: any;
  
  constructor(private sessionService: SessionService, private candidateService: CandidateService,
    private activeRoute: ActivatedRoute, private authService: AuthService,
    private router: Router,
    private titleService: Title, private location: Location) {
    this.titleService.setTitle("Online Ballot Candidate Statement Page");
  }

  ngOnInit() {
    this.getCandidateList();
    var sub = this.activeRoute.params.subscribe(params => {
      var id = +params['id']; // (+) converts string 'id' to a number
      this.candidateService.getCandidateDetailById(id).subscribe((response: any) => {
        if (response.status === 200) {
          this.candidateDetail = response.model.Candidate;
          this.titleService.setTitle(response.model.Candidate.CandidateName + ' Statement - 2026 CAPE Contract Ratification');
          console.log(response.model.Candidate);
        }

      }, error => {
        this.error = error;
      });
    });
    if (window.innerWidth < 825) {
      this.mobile = true;
    }
    if (window.innerWidth > 825) {
      setTimeout(() => this.removeLink(), 1500);
    }
  }

  ngAfterContentInit() {
    
  }

  private getCandidateList() {
    this.sessionService.getSessionValue(this.CONSTANTS.CANDIDATE_KEY).subscribe((response: any) => {
      var candidatesObj = JSON.parse(response['value']);
      if (candidatesObj !== null) {
        this.candidates = candidatesObj;
      }
    },
      error => {
        this.authService._sessionTimeout = true;
        this.authService.logout();
        this.router.navigate(['/#']);
      });
  }

  removeLink() {
    var anchors = document.querySelectorAll(".callLink");
    
    for (var i = 0; i < anchors.length; i++) {
      var span = document.createElement("span");
      if (anchors[i].className) {
        span.className = anchors[i].className;
      }

      if (anchors[i].id) {
        span.id = anchors[i].id;
      }

      span.innerHTML = anchors[i].innerHTML;

      anchors[i].parentNode.replaceChild(span, anchors[i]);
    }
  }

  returnToPosition() {
    this.position = (this.candidateDetail.ContestId - 1);
    this.router.navigate(['/voting'], { queryParams: { pageIndex: this.position } });
    //console.log(this.candidateDetail);
    //this.location.back()
  }
}



// WEBPACK FOOTER //
// ./src/app/features/candidate-statement/candidate-statement.component.ts